var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-5"},[_c('AdminNav'),_c('router-link',{staticClass:"btn btn-primary mb-4",attrs:{"to":"/admin/restaurants/new"}},[_vm._v(" New Restaurant ")]),_c('AdminRestaurantsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }